import React from 'react';
import classes from './TourTicketLazyLoading.scss';
import PreLoading from '../base/PreLoading/PreLoading';

const TourTicketLazyLoading = () => (
  <div className={classes.spinnerContainer}>
    <span className={classes.blur}><PreLoading size="extra-small" /></span>
  </div>
);

export default TourTicketLazyLoading;
